import React, { useEffect } from 'react';
import PropType from 'prop-types';
import _ from 'lodash';

// Atoms
import { CellsWrapper, Cell } from './Table.atoms';

// Components
import TableCell from './TableCell';

// Lib
import calculateColumnResult from '../../../lib/columnResult';
import { columnNamesTranslation, columnTooltips } from '../../../lib/constants/table';

// Context
import { ResultContext } from '../../Context/ResultContext';

const TableColumn = ({
	column, firstSection, middleSection, lastSection, onClick, announce, cancelAnnouncement, rollsLeft, opponentTable, command, columnId,
}) => {
	const { setScore = () => {} } = React.useContext(ResultContext);
	const result = calculateColumnResult(firstSection, middleSection, lastSection);

	useEffect(() => {
		setScore((prevState) => {
			const newState = _.clone(prevState);
			_.set(newState, `firstSection.${columnId}`, result.firstSectionResult);
			return newState;
		});
	}, [columnId, result.firstSectionResult, setScore]);

	useEffect(() => {
		setScore((prevState) => {
			const newState = _.clone(prevState);
			_.set(newState, `middleSection.${columnId}`, result.middleSectionResult);
			return newState;
		});
	}, [columnId, result.middleSectionResult, setScore]);

	useEffect(() => {
		setScore((prevState) => {
			const newState = _.clone(prevState);
			_.set(newState, `lastSection.${columnId}`, result.lastSectionResult);
			return newState;
		});
	}, [columnId, result.lastSectionResult, setScore]);

	return (
		<CellsWrapper key={column.id}>
			<Cell data-tip={columnTooltips[column.name]}>{columnNamesTranslation[column.name]}</Cell>
			{firstSection.map(cell => (
				<TableCell
					opponentTable={opponentTable}
					rollsLeft={rollsLeft}
					cancelAnnouncement={cancelAnnouncement}
					announce={announce}
					onClick={onClick}
					key={`${column.id} ${cell.name}`}
					cell={cell}
					column={column}
					command={command}
					columnId={columnId}
				/>
			))}
			<Cell>{result.firstSectionResult}</Cell>
			{middleSection.map(cell => (
				<TableCell
					opponentTable={opponentTable}
					rollsLeft={rollsLeft}
					cancelAnnouncement={cancelAnnouncement}
					announce={announce}
					onClick={onClick}
					key={`${column.id} ${cell.name}`}
					cell={cell}
					column={column}
					command={command}
					columnId={columnId}
				/>
			))}
			<Cell>{result.middleSectionResult}</Cell>
			{lastSection.map(cell => (
				<TableCell
					opponentTable={opponentTable}
					rollsLeft={rollsLeft}
					cancelAnnouncement={cancelAnnouncement}
					announce={announce}
					onClick={onClick}
					key={`${column.id} ${cell.name}`}
					cell={cell}
					column={column}
					command={command}
					columnId={columnId}
				/>
			))}
			<Cell>{result.lastSectionResult}</Cell>
		</CellsWrapper>
	);
};

TableColumn.propTypes = {
	rollsLeft: PropType.number.isRequired,
	cancelAnnouncement: PropType.func.isRequired,
	announce: PropType.shape({}).isRequired,
	onClick: PropType.func.isRequired,
	column: PropType.shape({
		name: PropType.string,
		id: PropType.string,
	}).isRequired,
	firstSection: PropType.arrayOf(PropType.shape({
		name: PropType.string,
		isActive: PropType.bool,
		value: PropType.number,
	})).isRequired,
	middleSection: PropType.arrayOf(PropType.shape({
		name: PropType.string,
		isActive: PropType.bool,
		value: PropType.number,
	})).isRequired,
	lastSection: PropType.arrayOf(PropType.shape({
		name: PropType.string,
		isActive: PropType.bool,
		value: PropType.number,
	})).isRequired,
};

export default TableColumn;
